import { connect } from 'react-redux'

import { withData, withStateMappedToProps, CATALOG, IS_AUTHENTICATED, SUBSCRIPTIONS, USER_CONFIG_YARA_ENABLED } from '../../redux/withData'

import TheComponent from './TryItS3.js';

const requiredData = [CATALOG, IS_AUTHENTICATED, SUBSCRIPTIONS, USER_CONFIG_YARA_ENABLED]

const mapStateToProps = state => {
  return withStateMappedToProps(state, requiredData)
}

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(withData(requiredData)(TheComponent))